export const HelpEmailLink = () => {
    return("hello@readtronic.com"); 
}